import { useState } from "react";
import { useNavigate } from "react-router-dom";

/*
 * 1% MODEL 마케팅 랜딩페이지 (시안 기반 신규)
 * - 화면(마크업/레이아웃)만 담당. 라우팅 연결(App.js)·지원 폼(ModelApply)은 다음 단계 impl-landing 담당.
 * - 실사진 미배치 상태: 인물/갤러리는 .mlp_ph 플레이스홀더로 구현.
 *   실사진은 src/images/landing/model/ 에 배치 후, 각 <Photo /> 자리에 <img> 를 넣어 교체.
 *   (지금은 파일이 없어 import 하지 않음 — 빌드 안전 + 레이아웃 안 깨짐)
 */

// 인물/갤러리 플레이스홀더 (고정비율은 CSS aspect-ratio 로 지정)
const Photo = ({ className = "", file }) => (
    <div className={`mlp_ph ${className}`} data-photo={file} aria-hidden="true">
        {/* 실사진 배치 시:
            import xxx from "../../images/landing/model/파일명";
            <img src={xxx} alt="설명" /> */}
    </div>
);

/* ---------- 인라인 아이콘 (이모지 미사용, currentColor 상속) ---------- */
const IconStar = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.9 6.6 19.7l1.2-6L3.3 9.3l6.1-.7L12 3z" />
    </svg>
);
const IconBadge = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="9" r="6" />
        <path d="M9 14.5L7.5 21l4.5-2.5L16.5 21 15 14.5" />
    </svg>
);
const IconScale = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v18M5 7h14M5 7l-2.5 6a3 3 0 006 0L6 7M18 7l-2.5 6a3 3 0 006 0L18 7M8 21h8" />
    </svg>
);
const IconDevice = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
        <path d="M10.5 18.5h3" />
    </svg>
);
const IconUpload = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 15V4M8 8l4-4 4 4M4 15v3a2 2 0 002 2h12a2 2 0 002-2v-3" />
    </svg>
);
const IconSearch = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="7" />
        <path d="M20 20l-3.5-3.5" />
    </svg>
);
const IconChat = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 5h16a1 1 0 011 1v10a1 1 0 01-1 1H9l-4 3v-3H4a1 1 0 01-1-1V6a1 1 0 011-1z" />
    </svg>
);
const IconCrown = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 8l3.5 3L12 5l4.5 6L20 8l-1.5 10h-13L4 8z" />
        <path d="M5.5 18h13" />
    </svg>
);
const IconGift = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 10h16v10H4zM4 10V8h16v2M12 8v12M12 8c-1.5-3-5-2.5-5 0 0 1 1 2 5 0zM12 8c1.5-3 5-2.5 5 0 0 1-1 2-5 0z" />
    </svg>
);
const IconCamera = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 8h3l1.5-2h7L17 8h3a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1z" />
        <circle cx="12" cy="13" r="3.2" />
    </svg>
);
const IconSparkle = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3l1.8 5L19 9.8 13.8 12 12 17l-1.8-5L5 9.8 10.2 8 12 3z" />
        <path d="M19 15l.7 2 2 .8-2 .7-.7 2-.7-2-2-.7 2-.8.7-2z" />
    </svg>
);
const IconHeart = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20s-7-4.6-9.2-8.4C1.2 8.7 2.6 5.5 5.8 5.5c1.9 0 3.2 1.1 4.2 2.4 1-1.3 2.3-2.4 4.2-2.4 3.2 0 4.6 3.2 3 6.1C19 15.4 12 20 12 20z" />
    </svg>
);
const IconCheck = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12.5l4.5 4.5L19 7" />
    </svg>
);
const IconInsta = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17" cy="7" r="1" fill="currentColor" stroke="none" />
    </svg>
);
const IconYoutube = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="6" width="18" height="12" rx="3.5" />
        <path d="M11 9.5l4 2.5-4 2.5v-5z" fill="currentColor" stroke="none" />
    </svg>
);
const IconBlog = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="4" width="16" height="16" rx="4" />
        <path d="M8 8h5a2.5 2.5 0 010 5H8V8zM8 13h5.5a2.5 2.5 0 010 5H8v-5z" />
    </svg>
);

const HERO_CARDS = [
    { ic: <IconStar />, tit: "외모 상위 1%", desc: "이상적인 외모·매력의 기준으로\n선정되는 프로그램" },
    { ic: <IconBadge />, tit: "공식 참여 프로그램", desc: "원픽이 직접 제안하는\n공식 1% 모델 프로그램" },
    { ic: <IconScale />, tit: "공정한 참여 기회", desc: "누구에게나 열려있는\n투명하고 공정한 심사" },
    { ic: <IconDevice />, tit: "간편한 온라인 참여", desc: "사진·프로필 제출로\n온라인에서 간편하게" },
];

const INTRO_CARDS = [
    { ic: <IconStar />, tit: "외모 상위 1% 기준", desc: "엄선된 기준으로 선정되는\n상위 1% 외모·매력" },
    { ic: <IconBadge />, tit: "참여형 1% 모델", desc: "선정된 분들이 직접 참여하는\n활동 중심 프로그램" },
    { ic: <IconGift />, tit: "활동 및 혜택 제공", desc: "참여 활동에 따른\n다양한 특전과 혜택" },
];

const PROCESS = [
    { ic: <IconUpload />, no: "01", tit: "사진 및 프로필 제출", desc: "정면 사진과 기본 프로필을\n간편하게 제출합니다." },
    { ic: <IconSearch />, no: "02", tit: "1% 모델 심사 과정", desc: "제출해주신 사진·프로필을\n담당자가 심사합니다." },
    { ic: <IconChat />, no: "03", tit: "참여 의사 결정", desc: "선정 안내 후 참여 의사를\n확인하고 결정합니다." },
    { ic: <IconCrown />, no: "04", tit: "1% 모델 선정 및 참여", desc: "최종 선정되어 1% 모델\n프로그램에 참여합니다." },
];

const WELCOME = [
    { ic: <IconCamera />, txt: "외모와 셀카 사진 등에\n자신 있는 분" },
    { ic: <IconSparkle />, txt: "새로운 경험과 평소\n모델에 관심이 많은 분" },
    { ic: <IconHeart />, txt: "솔로·연애·소개팅 등에\n관심이 많은 분" },
];

// 줄바꿈(\n) 포함 텍스트 렌더
const multiline = (str) =>
    str.split("\n").map((line, i, arr) => (
        <span key={i}>
            {line}
            {i < arr.length - 1 && <br />}
        </span>
    ));

const ModelLanding = () => {
    const [year] = useState(new Date().getFullYear());
    const navigate = useNavigate();

    // "1% 모델 지원하기" 버튼 → 지원 폼으로 이동
    const goApply = () => {
        navigate("/model/apply");
    };

    // "자세히 알아보기" — 소개 섹션으로 스크롤
    const goDetail = () => {
        const el = document.getElementById("model");
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div className="model_lp">
            {/* ===== 헤더 ===== */}
            <header className="mlp_header">
                <div className="mlp_inner">
                    <a href="#about" className="mlp_logo">ONEPICK</a>
                    <nav className="mlp_gnb">
                        <a href="#about">ABOUT</a>
                        <a href="#model">1% 모델</a>
                        <a href="#process">참여 과정</a>
                        <a href="#standard">1% 모델 기준</a>
                        <a href="#promo">특전 프로모션</a>
                    </nav>
                    <button type="button" className="mlp_btn mlp_btn_primary" onClick={goApply}>
                        1% 모델 지원하기
                    </button>
                </div>
            </header>

            {/* ===== 히어로 (ABOUT) ===== */}
            <section className="mlp_hero" id="about">
                <div className="mlp_inner">
                    <div className="mlp_hero_row">
                        <div className="mlp_hero_txt">
                            <span className="mlp_eyebrow">About 1% Model</span>
                            <h1 className="mlp_hero_tit">
                                ABOUT<br />
                                <span className="mlp_grad_txt">1% MODEL</span>
                            </h1>
                            <p className="mlp_hero_desc">
                                '외모 상위 1%'의 이상적인 외모·매력의 기준으로 선정되어
                                자사가 제안하는 1% 모델 프로그램 참여형입니다.
                            </p>
                            <div className="mlp_hero_btns">
                                <button type="button" className="mlp_btn mlp_btn_primary" onClick={goApply}>
                                    1% 모델 지원하기
                                </button>
                                <button type="button" className="mlp_btn mlp_btn_outline" onClick={goDetail}>
                                    자세히 알아보기
                                </button>
                            </div>
                        </div>
                        <div className="mlp_hero_visual">
                            <Photo file="hero_male.jpg" />
                            <Photo file="hero_female.jpg" />
                        </div>
                    </div>

                    <div className="mlp_hero_cards">
                        {HERO_CARDS.map((c, i) => (
                            <div className="mlp_feat_card" key={i}>
                                <div className="mlp_feat_ic">{c.ic}</div>
                                <h3>{c.tit}</h3>
                                <p>{multiline(c.desc)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ===== 1% 모델이란? ===== */}
            <section className="mlp_intro" id="model">
                <div className="mlp_inner">
                    <div className="mlp_intro_row">
                        <div className="mlp_intro_txt">
                            <span className="mlp_eyebrow">What is 1% Model</span>
                            <h2 className="mlp_sec_tit">1% 모델이란?</h2>
                            <p className="mlp_para" style={{ marginTop: "18px" }}>
                                1% 모델은 '외모 상위 1%'의 이상적인 외모와 매력의 기준으로
                                선정되는 원픽의 공식 참여형 프로그램입니다. 엄선된 심사를
                                거쳐 선정된 분들만 참여할 수 있습니다.
                            </p>
                            <p className="mlp_para">
                                복잡한 절차 없이 사진과 프로필 제출만으로 간편하게 지원할 수
                                있으며, 선정된 1% 모델에게는 다양한 활동 기회와 특전, 혜택이
                                제공됩니다.
                            </p>
                        </div>
                        <div className="mlp_intro_visual">
                            <Photo className="big" file="intro_1.jpg" />
                            <Photo className="small" file="intro_2.jpg" />
                        </div>
                    </div>

                    <div className="mlp_intro_cards">
                        {INTRO_CARDS.map((c, i) => (
                            <div className="mlp_feat_card" key={i}>
                                <div className="mlp_feat_ic">{c.ic}</div>
                                <h3>{c.tit}</h3>
                                <p>{multiline(c.desc)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ===== 1% 모델 선정 과정 ===== */}
            <section className="mlp_process" id="process">
                <div className="mlp_inner mlp_center">
                    <span className="mlp_eyebrow">Process</span>
                    <h2 className="mlp_sec_tit">1% 모델 선정 과정</h2>
                    <p className="mlp_sec_desc">
                        사진 제출부터 최종 선정까지, 4단계로 간편하게 진행됩니다.
                    </p>
                    <div className="mlp_process_grid">
                        {PROCESS.map((s, i) => (
                            <div className="mlp_step" key={i}>
                                <div className="mlp_step_ic">{s.ic}</div>
                                <div className="mlp_step_no">STEP {s.no}</div>
                                <h3>{s.tit}</h3>
                                <p>{multiline(s.desc)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ===== 1% MODEL 기준 (갤러리) ===== */}
            <section className="mlp_standard" id="standard">
                <div className="mlp_inner mlp_center">
                    <span className="mlp_eyebrow">Standard</span>
                    <h2 className="mlp_sec_tit">1% MODEL 기준</h2>
                    <p className="mlp_sec_desc">
                        원픽이 제안하는 1% 모델의 이상적인 외모·매력 기준입니다.
                    </p>
                    <div className="mlp_gallery">
                        {[1, 2, 3, 4, 5].map((n) => (
                            <Photo key={n} file={`standard_${n}.jpg`} />
                        ))}
                    </div>
                    <p className="mlp_standard_notice">
                        해당 인물은 AI로 제작된 가상 인물이며, 실제 1% 모델의 이미지와
                        가장 비슷하게 제작되었습니다.
                    </p>
                </div>
            </section>

            {/* ===== 특전 프로모션 ===== */}
            <section className="mlp_promo" id="promo">
                <div className="mlp_inner">
                    <div className="mlp_promo_row">
                        <div className="mlp_promo_txt">
                            <span className="mlp_badge">SPECIAL PROMOTION</span>
                            <h2 className="mlp_sec_tit">1% 모델 특전 프로모션</h2>
                            <div className="mlp_promo_price">
                                <strong>300,000원</strong>
                                <span>특전 지급</span>
                            </div>
                            <ul className="mlp_check_list">
                                <li>
                                    <span className="mlp_check_ic"><IconCheck /></span>
                                    1% 모델 선정 시, 특전 30만 원이 지급됩니다.
                                </li>
                                <li>
                                    <span className="mlp_check_ic"><IconCheck /></span>
                                    선정 후 담당자가 제공해주신 연락처로 개별 안내드립니다.
                                </li>
                                <li>
                                    <span className="mlp_check_ic"><IconCheck /></span>
                                    다양한 활동 기회와 추가 혜택을 함께 누릴 수 있습니다.
                                </li>
                            </ul>
                            <div className="mlp_hero_btns" style={{ marginTop: "34px" }}>
                                <button type="button" className="mlp_btn mlp_btn_primary" onClick={goApply}>
                                    1% 모델 지원하기
                                </button>
                            </div>
                        </div>
                        <div className="mlp_promo_visual">
                            <Photo file="promo.jpg" />
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== 이런 분을 환영합니다 ===== */}
            <section className="mlp_welcome">
                <div className="mlp_inner mlp_center">
                    <span className="mlp_eyebrow">Welcome</span>
                    <h2 className="mlp_sec_tit">이런 분을 환영합니다!</h2>
                    <div className="mlp_welcome_grid">
                        {WELCOME.map((w, i) => (
                            <div className="mlp_welcome_card" key={i}>
                                <div className="mlp_welcome_ic">{w.ic}</div>
                                <p>{multiline(w.txt)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ===== 푸터 ===== */}
            <footer className="mlp_footer">
                <div className="mlp_inner">
                    <div className="mlp_footer_top">
                        <div className="mlp_footer_logo">ONEPICK</div>
                        <div className="mlp_footer_info">
                            <ul>
                                <li>사업자등록번호 : 000-00-00000</li>
                                <li>대표자 : 서정승</li>
                            </ul>
                            <ul>
                                <li>주소 : 서울특별시</li>
                                <li>고객센터 운영 시간 : 13:00 - 21:30</li>
                            </ul>
                        </div>
                        <div className="mlp_footer_sns">
                            <a href="#none" aria-label="인스타그램"><IconInsta /></a>
                            <a href="#none" aria-label="유튜브"><IconYoutube /></a>
                            <a href="#none" aria-label="블로그"><IconBlog /></a>
                        </div>
                    </div>
                    <div className="mlp_copy">
                        COPYRIGHT© {year} 원픽 ALL RIGHTS RESERVED.
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default ModelLanding;
